export enum OperatorType {
    Personal = "PERSONAL",
    Enterprise = "ENTERPRISE",
}

export interface ContextOperator {
    id: string;
    name: string;
    type: OperatorType;
    features: GlobalFeatures[];
    avatarUrl: string | undefined;
    permissions: GlobalOperatorPermissions[];
}

export enum GlobalFeatures {
    Payments = "PAYMENTS",
    OperationsManual = "OPERATIONS_MANUAL",
    SpecificPermitApplication = "SPECIFIC_PERMIT_APPLICATION",
    MissionPlanner = "MISSION_PLANNER",
    Statements = "STATEMENTS",
    UseSpecificPermit = "USE_SPECIFIC_PERMIT",
    UtmSupervisorIntegration = "UTM_SUPERVISOR_INTEGRATION",
    WeatherForecast = "WEATHER_FORECAST",
    AviationLaw2025 = "AVIATION_LAV_2025",
    AviationLaw2025Insurance = "AVIATION_LAV_2025_INSURANCE",
    ESoraUpgradeAltmoc = "ESORA_UPGRADE_ALTMOC",
    PersonalDataChangeRequest = "PERONALDATA_CHANGE_REQUEST",
    GeotilerRasterProxy = "GEOTILER_RASTER_PROXY",
    PermissionConfirmationFiles = "PERMISSION_CONFIRMATION_FILES",
    EsoraMitigationM1bHistoricalData = "ESORA_MITIGATION_M1B_HISTORICAL_DATA",
    FlightSimulatorInstructor = "FLIGHT_SIMULATOR_INSTRUCTOR",
    FlightSimulatorAdmin = "FLIGHT_SIMULATOR_ADMIN",
    TrainingSimulatorModule = "TRAINING_SIMULATOR_MODULE",
    NdisAuthenticationInDt = "KSID_AUTHENTICATION_IN_DT",
}

export enum GlobalOperatorPermissions {
    OperatorManage = "Operator.MANAGE",
    OperatorRead = "Operator.READ",
    OperatorOperationsManualEdit = "OperatorOperationsManual.EDIT",
    OperatorOperationsManualRead = "OperatorOperationsManual.READ",
    OperatorMembersRead = "OperatorMembers.READ",
    OperatorMissionsPlan = "OperatorMissions.PLAN",
    OperatorMissionsPilot = "OperatorMissions.PILOT",
    OperatorMissionsRead = "OperatorMissions.READ",
    OperatorUavsUse = "OperatorUavs.USE",
    OperatorUavsShare = "OperatorUavs.SHARE",
    OperatorUavsManage = "OperatorUavs.MANAGE",
    OperatorUavsRead = "OperatorUavs.READ",
    OperatorUavModelsManage = "OperatorUavModels.MANAGE",
    OperatorUavModelsUse = "OperatorUavModels.USE",
    OperatorUavModelsNonCustomModelEdit = "OperatorUavModels.NON_CUSTOM_MODEL_EDIT",
    OperatorSpecificPermitsUse = "OperatorSpecificPermits.USE",
    OperatorSpecificPermitsCreateApplication = "OperatorSpecificPermits.CREATE_APPLICATION",
    OperatorSpecificPermitsApply = "OperatorSpecificPermits.APPLY",
    OperationalStatementMakeStatement = "OperationalStatement.MAKE_STATEMENT",
}
